<template>
  <flipper :status="maquina.status" style="height: 100%; width: 50%" :active="field === 'oee'">
    <Frame title="Máquina">
      <button
        v-if="fake"
        style="position:absolute; width: 100%; height: 100%; top: 0; left: 0; background-color: transparent; border: none"
        @click="fakeStatusChange"
      ></button>
      <div class="padding">
        <rlabel
          class="row name"
          :text="machineLabel === 1 ? maquina.codigo : machineLabel === 2 ? maquina.descricao : maquina.codigo + '-' + maquina.descricao"
        ></rlabel>
        <div class="row-large">
          <div class="col">
            <div class="row">
              <Frame title="Ordem">
                <span class="centered">
                  {{
                  maquina.ordem.substring(0, Math.min(maquina.ordem.length, 20))
                  }}
                </span>
              </Frame>
              <Frame title="Peça">
                <span class="centered">
                  {{
                  maquina.peca.substring(0, Math.min(maquina.peca.length, 20))
                  }}
                </span>
              </Frame>
            </div>
            <div class="main-chart">
              <Frame title="OEE" v-if="field === 'oee'">
                <ChartContainer id="oee">
                  <Doughnut color="#006064" v-bind:complete="maquina.oee" />
                </ChartContainer>
              </Frame>
              <Frame title="Disponibilidade" v-else-if="field === 'disponibilidade'">
                <ChartContainer id="oee">
                  <Doughnut
                    color="rgba(54, 162, 235, 0.6)"
                    v-bind:complete="maquina.disponibilidade"
                  />
                </ChartContainer>
              </Frame>
              <Frame title="Qualidade" v-else-if="field === 'qualidade'">
                <ChartContainer id="oee">
                  <Doughnut color="#90A4AE" v-bind:complete="maquina.qualidade" />
                </ChartContainer>
              </Frame>
            </div>
          </div>
          <div class="col columns">
            <Frame title="Desempenho" v-if="field === 'oee'">
              <FrameContent>
                <ChartContainer>
                  <Doughnut color="#F57F17" v-bind:complete="maquina.desempenho" />
                </ChartContainer>
              </FrameContent>
            </Frame>
            <Frame title="Disponibilidade" v-if="field === 'oee'">
              <FrameContent>
                <ChartContainer>
                  <Doughnut
                    color="rgba(54, 162, 235, 0.6)"
                    v-bind:complete="maquina.disponibilidade"
                  />
                </ChartContainer>
              </FrameContent>
            </Frame>
            <Frame title="Qualidade" v-if="field === 'oee'">
              <FrameContent>
                <ChartContainer>
                  <Doughnut color="#90A4AE" v-bind:complete="maquina.qualidade" />
                </ChartContainer>
              </FrameContent>
            </Frame>
            <Frame title="Principais Paradas" v-else-if="field === 'disponibilidade'" class="fill">
              <chart-container>
                <bar-chart
                  color="#E05959"
                  label="Disponibilidade"
                  v-bind:valores="principaisParadas(maquina.indice)"
                  suffix="h"
                ></bar-chart>
              </chart-container>
            </Frame>
            <Frame title="Principais Defeitos" v-else-if="field === 'qualidade'" class="fill">
              <chart-container>
                <bar-chart
                  color="#2Aa987"
                  label="Qualidade"
                  v-bind:valores="principaisDefeitos(maquina.indice)"
                ></bar-chart>
              </chart-container>
            </Frame>
          </div>
        </div>
        <div class="status-frame">
          <Frame title="Status" v-if="field === 'oee'">
            <status-prod
              :status="maquina.status"
              :atraso="maquina.atraso"
              :motivo="maquina.motivoParada"
              :progress="maquina.progress"
              :total="maquina.total"
              :tempoEstado="maquina.tempoEstado"
              :extra="'00:15:00'"
            ></status-prod>
          </Frame>
          <Frame title="Histórico de Status Máquina" v-else-if="field === 'disponibilidade'">
            <frame-content style="display: flex">
              <chart-legend></chart-legend>
              <chart-container>
                <timeline-chart
                  label="Disponibilidade"
                  v-bind:valores="historicoStatus(maquina.indice)"
                ></timeline-chart>
              </chart-container>
            </frame-content>
          </Frame>
          <div
            v-if="field === 'qualidade'"
            style="display: flex; border-radius: 1rem; margin-top: 0.6rem; height: 100%"
          >
            <Frame title="Boas" background="#4ac200" style="margin-right: 0.3rem;">
              <p class="frame-qualidade">{{Math.floor(Math.random() * 3000)}}</p>
            </Frame>
            <Frame title="Defeituosas" background="#ffa200" style="margin-left: 0.3rem">
              <p class="frame-qualidade">{{Math.floor(Math.random() * 100)}}</p>
            </Frame>
          </div>
        </div>
      </div>
    </Frame>
  </flipper>
</template>

<script>
import Frame from "../Frame.vue";
import StatusProd from "../StatusProd.vue";
import Doughnut from "../charts/Doughnut.js";
import ChartContainer from "../ChartContainer.vue";
import FrameContent from "../FrameContent.vue";
import ResponsiveLabel from "../ResponsiveLabel.vue";

import Legend from "../Legend.vue";
import Timeline from "../charts/Timeline.js";
import HorizontalBar from "../charts/HorizontalBar.js";
import Flipper from "../FlippingCard.vue";

import fakeData from "../../store/fakeData.js";

export default {
  name: "Machine2",
  components: {
    Frame,
    StatusProd,
    Doughnut,
    ChartContainer,
    FrameContent,
    rlabel: ResponsiveLabel,
    "timeline-chart": Timeline,
    "chart-legend": Legend,
    "bar-chart": HorizontalBar,
    flipper: Flipper
  },
  props: {
    maquina: Object,
    field: String
  },
  methods: {
    fakeStatusChange() {
      if (this.maquina.status === "Produção")
        fakeData[this.maquina.indice - 1].status = "Parada";
      else if (this.maquina.status === "Parada")
        fakeData[this.maquina.indice - 1].status = "Ocioso";
      else if (this.maquina.status === "Ocioso")
        fakeData[this.maquina.indice - 1].status = "Setup";
      else if (this.maquina.status === "Setup")
        fakeData[this.maquina.indice - 1].status = "Produção";
    }
  },
  computed: {
    machineLabel() {
      return this.$store.state.machineLabel;
    },
    fake() {
      return this.$store.state.fake;
    },
    principaisParadas() {
      return index => ({
        labels: [
          "Injustificada",
          "Manutenção Corretiva",
          "Troca de Ferramenta",
          "Liberada de Manutenção",
          "Manutentor na Máquina"
        ],
        valores:
          index === 1
            ? [358.33, 140.12, 140, 140, 3.4]
            : [220.2, 210.42, 134, 20, 10.5]
      });
    },
    principaisDefeitos() {
      return index => ({
        labels: [
          "Quebrada",
          "Corte Incorreto",
          "Porosidade",
          "Deformidade",
          "Outros Defeitos"
        ],
        valores: index === 1 ? [135, 72, 66, 40, 10] : [240, 91, 77, 76, 14]
      });
    },
    historicoStatus() {
      return index => {
        const today = this.moment();
        const yesterday = today.clone().add(-1, "day");
        const formatConfig = "YYYY-MM-DD[T]HH:mm:ss";
        return [
          {
            gap: [
              yesterday
                .hour(index === 1 ? 18 : 13)
                .minute(0)
                .second(0)
                .format(formatConfig),
              yesterday
                .hour(22)
                .minute(0)
                .second(0)
                .format(formatConfig)
            ],
            status: index === 1 ? "Parada" : "Produção"
          },
          {
            gap: [
              yesterday
                .hour(22)
                .minute(0)
                .second(0)
                .format(formatConfig),
              today
                .hour(index === 1 ? 3 : 2)
                .minute(index === 1 ? 0 : 10)
                .second(0)
                .format(formatConfig)
            ],
            status: index === 1 ? "Produção" : "Ocioso"
          },
          {
            gap: [
              today
                .hour(index === 1 ? 3 : 2)
                .minute(index === 1 ? 0 : 10)
                .second(0)
                .format(formatConfig),
              today
                .hour(3)
                .minute(16)
                .second(0)
                .format(formatConfig)
            ],
            status: index === 1 ? "Ocioso" : "Parada"
          },
          {
            gap: [
              today
                .hour(3)
                .minute(16)
                .second(0)
                .format(formatConfig),
              today
                .hour(4)
                .minute(0)
                .second(0)
                .format(formatConfig)
            ],
            status: "Em Setup"
          },
          {
            gap: [
              today
                .hour(4)
                .minute(0)
                .second(0)
                .format(formatConfig),
              today
                .hour(15)
                .minute(20)
                .second(0)
                .format(formatConfig)
            ],
            status: index === 1 ? "Produção" : "Parada"
          },
          {
            gap: [
              today
                .hour(15)
                .minute(20)
                .second(0)
                .format(formatConfig),
              today
                .hour(16)
                .minute(0)
                .second(0)
                .format(formatConfig)
            ],
            status: "Ocioso"
          },
          {
            gap: [
              today
                .hour(16)
                .minute(0)
                .second(0)
                .format(formatConfig),
              today
                .hour(23)
                .minute(0)
                .second(0)
                .format(formatConfig)
            ],
            status: "Produção"
          }
        ];
      };
    }
  }
};
</script>

<style scoped>
.padding {
  padding: 0 0.8rem;
  height: 100%;
}

.row {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 8rem;
  font-size: 3.6rem;
  border-radius: 1rem;
}

.row.name {
  font-size: 5rem;
}

.row > :first-child {
  margin-right: 0.8rem;
}

.row-large {
  height: 60%;
  display: flex;
}

.main-chart {
  border-radius: 1rem;
  height: calc(100% - 10rem);
}

span.centered {
  height: 100%;
  display: block;
  text-align: center;
  font-size: 2vw;
}

.col {
  height: 100%;
  width: 50%;
}

.col:first-child {
  margin-right: 0.8rem;
}

.columns {
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  height: 100%;
}

.columns > * {
  max-height: 33%;
  height: 33%;
}

.status-frame {
  height: calc(100% - 60% - 8.8rem);
  border-radius: 1rem;
  font-size: 3.5rem;
}

#oee {
  padding: 2.5rem;
}

.fill {
  height: 100% !important;
  max-height: 100%;
}

.frame-qualidade {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  font-size: 4vw;
}
</style>
